// @ts-nocheck
// import produce from 'immer';
import { useEffect, useState } from 'react';
import { RJSFSchema } from '@rjsf/utils';
import clientForm from '../components/Clients/clientFormSchema.json';
import useUIModules from './useUIModules';

const useClientForm = () => {
  const { uiModules, isLoading: isUIModulesLoading } = useUIModules();
  const [updated, setUpdated] = useState(false);
  const [clientFormSchema, setSchema] = useState<RJSFSchema>(
    clientForm as RJSFSchema
  );
  useEffect(() => {
    if (uiModules) {
      const enums = uiModules.map((module) => module.Id);
      const modules = uiModules.map(
        (module) => `${module.Title} - (${module.Path})`
      );
      const anyOf = enums.map((elem, index) => ({
        type: 'number',
        enum: [elem],
        title: modules[index],
      }));
      setSchema((schema) => {
        schema = Object.assign({}, schema, {
          properties: Object.assign({}, schema.properties, {
            ModuleIds: Object.assign({}, schema.properties.ModuleIds, {
              items: Object.assign({}, schema.properties.ModuleIds.items, {
                anyOf,
              }),
            }),
          }),
        });
        return schema;
      });
      setUpdated(true);
    }
  }, [uiModules]);

  return {
    clientFormSchema,
    isLoading: isUIModulesLoading,
    updated,
  };
};
export default useClientForm;
